import { useMaterialsStore } from '@/stores/configurations/materials'
import { useProductsStore } from '@/stores/configurations/products'
import { useProductTemplatesStore } from '@/stores/orders/productTemplates'
import { usePapersService } from '@/views/Configurations/Materials/services/papersService'
import { useProductsService } from '@/views/Configurations/Products/services/productsService'
import { useProductTemplatesService } from '@/views/Orders/ProductTemplates/services/productTemplatesService'

let prefetchPromise: Promise<void> | null = null

export async function prefetchOrderProductPageData(): Promise<void> {
    if (prefetchPromise) {
        return prefetchPromise
    }

    const productsStore = useProductsStore()
    const materialsStore = useMaterialsStore()
    const productTemplatesStore = useProductTemplatesStore()

    const productsService = useProductsService({ store: productsStore })
    const productTemplatesService = useProductTemplatesService({ store: productTemplatesStore })
    const papersService = usePapersService({ store: materialsStore })

    prefetchPromise = Promise.all([
        productsService.fetchProductTypes(),
        productsService.fetchProductProductionProperties({ orderAvailable: true }),
        productsService.fetchProductComponents(),
        productsService.fetchProductionProcesses({ isVirtual: false }),
        papersService.fetchPapers(),
        productTemplatesService.fetchProductionFileInPaths(),
        productTemplatesService.fetchFoldingTypes()
    ]).then(() => undefined)

    try {
        await prefetchPromise
    } catch (error) {
        prefetchPromise = null
        throw error
    }
}

export function resetOrderProductPagePrefetch(): void {
    prefetchPromise = null
}
